<template>
    <div class="wrap-item-electronic-lecture b-item-lecture">
        <router-link v-if="type == PLANING_LESSON_WAREHOUSE" class="link-click" 
            :title="item.name"
            :to="{ path: getPath, query: { id: item.id, name: item.name, isEdit: 1 } }"
            target="_blank">
        </router-link>
        <router-link v-else class="link-click" 
            :title="item.name"
            :to="{ path: getPath, query: { id: item.id, name: item.name } }"
            target="_blank">
        </router-link>
        <div class="header-item-electronic-lecture">
            <div class="display-flex justify-content-between b-ellipsis" :title="item.name">
                <strong>
                    {{ item.name }}
                </strong>
                <!-- <div class="wrap-action"
                    v-if="type == PLANING_LESSON_WAREHOUSE || type == ELECTRONIC_LECTURE_WAREHOUSE">
                    <div class="dropdown">
                        <i @click="handleShowDropdown" class="icon-more" href="#" role="button" id="dropdownMenuLink"
                            data-toggle="dropdown" aria-expanded="false"></i>

                        <div class="dropdown-menu b-drop-down" aria-labelledby="sss">
                            <a @click="handleEditItem" class="dropdown-item" href="#">Sửa</a>
                            <a @click="handleDeleteItem" class="dropdown-item" href="#">Xóa</a>
                            <div class="dropdown dropright">
                                <a @click="handleClickSubmenu" class="dropdown-item" href="#"
                                    data-toggle="dropdown">Giao bài</a>
                            </div>
                            <div @click="handleNotStopDropdown" v-if="isShowDropdownSubMenu"
                                :class="{ 'show': isShowDropdownSubMenu }" class="dropdown-menu min-width-30r b-drop-down-item">
                                <ModalAssignLesson :type="type" :item="item"
                                    @handleAssignSuccess="handleAssignSuccess" @handleCloseDropdown="handleShowDropdown" />
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>

        </div>
        <div class="body-item-electronic-lecture">
            <div class="subject-electronic-lecture b-ellipsis">
                Môn học: {{ item.subjectName }}

            </div>
            <div class="class-electronic-lecture b-ellipsis">
                Khối: {{ item.className }}
            </div>
            <div class="count-comment">
                Số bình luận: {{ item.countComment }}
            </div>
            <div v-if="type == ElectronicLectureWarehouse" class="type-public display-flex">
                <label for="is-public">Công khai:</label>
                <b-form-checkbox @change="onChangePublic" v-model="item.isPublic" class="margin-left-10"
                    name="is-public" switch>
                </b-form-checkbox>
            </div>
        </div>

        <div class="footer-item-electronic-lecture"
            v-if="type == PLANING_LESSON_WAREHOUSE || type == ELECTRONIC_LECTURE_WAREHOUSE">
            <div class="display-flex-center cg-1">
                <a @click="handleDeleteItem" class="text-danger" href="#">Xóa</a>

            </div>
            <div class="display-flex-center" @click="handleClickEdit">
                <router-link :to="{ path: getPath, query: { id: item.id, name: item.name, isEdit: 1 } }" :disabled="item.isPublic && type == 2"
                    target="_blank"><a class="btn btn-primary btn-assign">Sửa</a></router-link>
            </div>
            <div class="display-flex-center" @click="handleClickAssignPost">
                <a @click="handleClickSubmenu" class="btn btn-primary btn-assign" :disabled="!item.isPublic && type == 2" href="#">Giao bài</a>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { changePublicLessonClassSchool } from './../../_api/LessonClassSchoolServices'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../constants/constants_enum'
import ModalAssignLesson from './ModalAssignLesson'
export default {
    name: "ItemElectronicLecture",
    components: {
        ModalAssignLesson
    },
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        type: {
            type: Number,
            default: 0
        },
    },
    watch: {
        //'item.isPublic':'handleChangePublic'
    },
    data() {
        return {
            PLANING_LESSON_ASSIGN,
            PLANING_LESSON_WAREHOUSE,
            ELECTRONIC_LECTURE_WAREHOUSE,
            ELECTRONIC_LECTURE_ASSIGN,
            formatDate: "HH:mm-DD/MM/YYYY",
            ElectronicLecturesAssign: 1,
            ElectronicLectureWarehouse: 2,
            statusEnum: {
                '1': 'Bài mới',
                '2': 'Bài đang hoàn thành',
                '3': 'Bài đã hoàn thành'
            }
        }
    },
    computed: {
        textStatus() {
            return ''
            //return this.statusEnum[`${this.item.status}`]
        },
        getPath() {
            if (this.type == ELECTRONIC_LECTURE_WAREHOUSE) {
                return '/kho-bai-giang/bai-giang-dien-tu'
            } else if (this.type == PLANING_LESSON_WAREHOUSE) {
                return '/kho-ke-hoach-bay-day/ke-hoach-bai-day'
            }
            else if (this.type == PLANING_LESSON_ASSIGN) {
                return '/ke-hoach-da-giao'
            }
            else if (this.type == ELECTRONIC_LECTURE_ASSIGN) {
                return '/bai-giang-dien-tu-da-giao'
            }
            return ''
        }
    },
    mounted() {

    },
    methods: {
        moment,
        handleAssignSuccess() {
            //this.isShowDropdownSubMenu = false
        },
        handleShowDropdown() {
            //this.isShowDropdownSubMenu = false
        },
        handleNotStopDropdown(e) {
            e.stopPropagation();
            //e.preventDefault();
        },
        handleClickSubmenu(e) {

            if (this.item.isPublic && this.type == 2) {
                this.$emit('handleOpenModalAssignLesson', this.item)
                //this.$emit('handleAssignSuccess')
            }
            else if (this.type == 4) {
                this.$emit('handleOpenModalAssignLesson', this.item)
            }
            else {
                //this.isShowDropdownSubMenu = false
                this.$toast.error('Bài giảng điện tử chưa được công khai')
            }

            this.handleNotStopDropdown(e)
        },
        handleEditItem() {
            this.$emit('handleEditItem', this.item)
        },
        handleDeleteItem() {
            this.$emit('handleDeleteItem', this.item)

        },
        onChangePublic(isCheck) {
            if(!isCheck){
                this.item.isPublic = true
                this.$emit('handleWarningPublicToPrivate',this.item)
                return
            }
            let param = {
                id: this.item.id,
                isPublic: isCheck
            }
            this.handleChangePublic(param)
        },
        handleChangePublic(param) {
            changePublicLessonClassSchool(param).then((res) => {
                if (res && res.data && !res.errors) {
                    this.$toast.success('Thay đổi chế độ thành công')
                }
            })
        },
        handleClickEdit() {
            if (this.item.isPublic && this.type == 2) {
                this.$emit('handleOpenModalWarningEdit')
            }
        },
        handleClickAssignPost() {
            if (!this.item.isPublic && this.type == 2) {
                this.$emit('handleOpenModalWarningAssignPost')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
// .wrap-action {
//     position: relative;

//     .dropdown-item {
//         position: absolute;
//         background: white;
//         border: 1px solid #dfdfdf;
//         z-index: 1;
//         border-radius: 10px;
//         padding: 9px;
//         left: -75px;
//         width: 10rem;

//         .item:hover {
//             color: #0f3dba;
//         }
//     }
// }
.min-width-30r {
    min-width: 30rem !important;
}

.link-item {
    color: black;
}

.margin-left-10 {
    margin-left: 10px;
}

.wrap-item-electronic-lecture {
    color: black;
    margin-top: 10px;
    border-radius: 20px;
    min-height: 10rem;
    padding: 0px;
    border: 1px solid #dfdfdf;
    display: flex;
    flex-direction: column;
    justify-content: left;
}

.header-item-electronic-lecture {
    padding: 0.8rem 1rem;
    border-bottom: 1px solid #dfdfdf;
    background-color: #0f3dba;
    border-radius: 20px 20px 0px 0px;
    color: white;
}

.body-item-electronic-lecture {
    padding: 0.5rem 1rem;
}

.footer-item-electronic-lecture {
    padding: 0 1rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
}

.btn-assign {
    border-radius: 20px;
    background-color: #0f3dba;
    padding-left: 2rem;
    padding-right: 2rem;
    color: white !important;
}

.b-item-lecture {
    position: relative;
}

.link-click {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 0;
}
</style>